import { AssetIdAndLayerId, BuilderTemplateId } from '../builderTemplate';
import { BeforeAfterPeriodType } from '../integration';
import { UploadId } from '../upload';

// Arbitrarily defined, don't want to allow users to submit excessively long descriptions
export const CUSTOM_LIST_DESCRIPTION_MAX_LENGTH = 256;
export interface ClubReadyDateRangeOptionDto {
    from: Date;
    to: Date;
}

export interface ClubReadyBeforeAfterDateOptionDto {
    period: BeforeAfterPeriodType;
    date: Date;
}

export enum ClubReadyListType {
    active = 'active',
    inactive = 'inactive',
    prospects = 'prospects',
    cooledOffProspects = 'cooled-off-prospects',
    custom = 'custom',
}

export type ClubReadyActiveListFetchOptions = {
    type: ClubReadyListType.active;
    activityPeriod: ClubReadyBeforeAfterDateOptionDto | null;
};

export type ClubReadyInactiveListFetchOptions = {
    type: ClubReadyListType.inactive;
    activityPeriod: ClubReadyBeforeAfterDateOptionDto | null;
};

export type ClubReadyProspectsListFetchOptions = {
    type: ClubReadyListType.prospects;
    addedBetweenRange: ClubReadyDateRangeOptionDto | null;
};

export type ClubReadyCooledOffProspectsListFetchOptions = {
    type: ClubReadyListType.cooledOffProspects;
};

export type ClubReadyCustomListFetchOptions = {
    type: ClubReadyListType.custom;
    emailListUploadId: UploadId;
    listDescription?: string;
};

export type ClubReadyListFetchOption =
    | ClubReadyActiveListFetchOptions
    | ClubReadyCooledOffProspectsListFetchOptions
    | ClubReadyCustomListFetchOptions
    | ClubReadyInactiveListFetchOptions
    | ClubReadyProspectsListFetchOptions;

export interface SendClubReadyCampaignDto {
    recipientLists: ClubReadyListFetchOption[];
    emailTemplateId: BuilderTemplateId;
    subject: string;
    scheduleTime?: Date | null;
    linkedAssetLibraryAssetIds: AssetIdAndLayerId[] | null;
    uploadId: UploadId;
}

export const ClubReadyMergeFields = [
    'location_address_city',
    'location_address_street',
    'location_email',
    'location_name',
    'location_phone_number',
    'location_postal_code',
    'location_state',
    'to_email_address',
    'to_first_name',
    'to_last_name',
    'current_year',
] as const;
export type ClubReadyMergeField = (typeof ClubReadyMergeFields)[number];
